import { defaultFormState } from '@/presentation/components/models';
import { atom } from 'recoil';
export const trasferFundsModalState = atom({
    key: 'trasferFundsModalState',
    default: Object.assign({ isLoading: true, accountFrom: null, accountTo: null, amount: 0, amountError: '', accountFromError: '', accountToError: '', correct: false, isInsufficientFunds: false }, defaultFormState)
});
